import { FlexRow } from '@/components/common/Flex';
import { Divider, DividerProps, FlexProps } from '@chakra-ui/react';
import { Text } from './Typography';

interface DividerWithTextProps extends FlexProps {
    text: string;
    color?: DividerProps['borderColor'];
}

export default function DividerWithText({
    text,
    color,
    ...props
}: DividerWithTextProps) {
    return (
        <FlexRow align="center" {...props}>
            <Divider borderColor={color} />
            <Text color="textMuted" fontWeight="semibold" mx={2}>
                {text}
            </Text>
            <Divider borderColor={color} />
        </FlexRow>
    );
}
